import { gql } from "@apollo/client";

export const GET_WORKING_HOURS = gql`
  query GetWorkingHours(
    $staffIds: [Int]
    $groupId: Int
    $hours24: String
    $sorted: Boolean
  ) {
    getWorkingHours(
      staffIds: $staffIds
      groupId: $groupId
      hours24: $hours24
      sorted: $sorted
    ) {
      id
      day
      onJob
      startTime
      endTime
      groupId
      staffIds
      parentId
    }
  }
`;

export const GET_STAFF_WORKING_HOURS_FOR_BOOKING_TYPE = gql`
  query GetStaffWorkingHoursForBookingType(
    $bookingTypeId: ID!
    $hours24: String
  ) {
    getStaffWorkingHoursForBookingType(
      bookingTypeId: $bookingTypeId
      hours24: $hours24
    ) {
      bookingTypeId
      groupId
      staffId
      workingHours {
        id
        groupId
        day
        onJob
        startTime
        endTime
        parentId
      }
      workingHourOverrides {
        whOverrideGroupId
        startTime
        endTime
      }
      workingHourOverrideGroup {
        date
      }
    }
  }
`;

export const GET_WORKING_HOUR_OVERRIDES = gql`
  query GetWorkingHourOverrides($staffId: Int!, $hours24: String) {
    getWorkingHourOverrides(staffId: $staffId, hours24: $hours24) {
      id
      startTime
      endTime
      whOverrideGroupId
    }
  }
`;

export const GET_WORKING_HOUR_OVERRIDE_GROUPS = gql`
  query GetWorkingHourOverrideGroups($staffId: Int!) {
    getWorkingHourOverrideGroups(staffId: $staffId) {
      id
      title
      startDate
      endDate
      workingHourOverrides {
        id
        whOverrideGroupId
        startTime
        endTime
      }
    }
  }
`;
export const GET_WORKING_HOUR_GROUP = gql`
  query GetWorkingHourGroupByGroupId($groupId: Int!) {
    getWorkingHourGroupByGroupId(groupId: $groupId) {
      id
      timeZone {
      id
      timezone
      }
    }
  }
`;

export const GET_STAFF_WORKING_HOUR = gql`
query GetStaffAvailability($staffIds: [ID!], $bookingTypeId: ID!, $startDate: String,$timezone: String, $viewType: String, $viewCalendar: String ) {
  getStaffAvailability( 
    staffIds: $staffIds,  
    bookingTypeId: $bookingTypeId, 
    startDate: $startDate,
    timezone : $timezone,
    viewType : $viewType,
    viewCalendar: $viewCalendar,
  ) {
    availability {
      date
      day
      timeSlots {
        time
        availableStaff
      }
      }
    }
  }
`;
